/** @jsx jsx */
/** @jsxFrag React.Fragment */
// @ts-check
import { jsx } from 'theme-ui';
import './frontend-2.min.css';
import './frontend.min.css';
import './post-39.css';
import './post-3383.css';
import Menubar from './Menubar';
import { Helmet } from 'react-helmet';
import React from 'react';
import { useFavorites } from '@bottlebooks/gatsby-plugin-bookmarks/src';

export default function Header({ children, locale, ...rest }) {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          id="font-awesome-5-all-css"
          href="/font-awesome/css/all.min.css"
          media="all"
        />
        <link
          rel="stylesheet"
          id="font-awesome-4-shim-css"
          href="/font-awesome/css/v4-shims.min.css"
          media="all"
        />
      </Helmet>
      <div
        data-elementor-type="header"
        data-elementor-id={3383}
        className="elementor elementor-3383 elementor-location-header elementor-kit-39"
        data-elementor-settings="[]"
      >
        <div className="elementor-section-wrap">
          <TopNavbar />
          <Menubar />
        </div>
      </div>
    </>
  );
}

function TopNavbar() {
  const { favorites } = useFavorites();
  return (
    <section
      className="elementor-section elementor-top-section elementor-element elementor-element-26562d0c elementor-section-height-min-height elementor-section-content-middle elementor-section-full_width elementor-section-height-default elementor-section-items-middle"
      data-id="26562d0c"
      data-element_type="section"
      data-settings='{"background_background":"classic"}'
    >
      <div className="elementor-container elementor-column-gap-no">
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1a0558b"
          data-id="1a0558b"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-125f65d3 elementor-icon-list--layout-inline elementor-mobile-align-center elementor-hidden-phone elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
              data-id="125f65d3"
              data-element_type="widget"
              id="top-header"
              data-widget_type="icon-list.default"
            >
              <div className="elementor-widget-container">
                <ul className="elementor-icon-list-items elementor-inline-items">
                  <li className="elementor-icon-list-item elementor-inline-item">
                    <a href="tel:02038719210">
                      <span className="elementor-icon-list-icon">
                        <i aria-hidden="true" className="fas fa-phone" />{' '}
                      </span>
                      <span className="elementor-icon-list-text">
                        +44 (0) 20 3871 9210
                      </span>
                    </a>
                  </li>
                  <li className="elementor-icon-list-item elementor-inline-item">
                    <a href="mailto:hello@northsouthwines.co.uk">
                      <span className="elementor-icon-list-icon">
                        <i aria-hidden="true" className="far fa-envelope" />{' '}
                      </span>
                      <span className="elementor-icon-list-text">
                        hello@northsouthwines.co.uk
                      </span>
                    </a>
                  </li>
                  <li className="elementor-icon-list-item elementor-inline-item">
                    <span className="elementor-icon-list-icon">
                      <i aria-hidden="true" className="far fa-clock" />{' '}
                    </span>
                    <span className="elementor-icon-list-text">
                      Mon - Fri: 8.30 to 5pm{' '}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3273c0bb"
          data-id="3273c0bb"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            <div
              className="elementor-element elementor-element-352d981 elementor-shape-square e-grid-align-right e-grid-align-mobile-right elementor-grid-0 elementor-widget elementor-widget-global elementor-global-4016 elementor-widget-social-icons"
              data-id="352d981"
              data-element_type="widget"
              data-widget_type="social-icons.default"
            >
              <div className="elementor-widget-container">
                <div className="elementor-social-icons-wrapper elementor-grid">
                  <span className="elementor-grid-item">
                    <a
                      className="elementor-icon elementor-social-icon elementor-social-icon-facebook-f elementor-repeater-item-5646027"
                      href="https://www.facebook.com/northsouthwines/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="elementor-screen-only">Facebook-f</span>
                      <i className="fab fa-facebook-f" />{' '}
                    </a>
                  </span>
                  <span className="elementor-grid-item">
                    <a
                      className="elementor-icon elementor-social-icon elementor-social-icon-twitter elementor-repeater-item-72bc942"
                      href="https://twitter.com/northsouthwines"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="elementor-screen-only">Twitter</span>
                      <i className="fab fa-twitter" />{' '}
                    </a>
                  </span>
                  <span className="elementor-grid-item">
                    <a
                      className="elementor-icon elementor-social-icon elementor-social-icon-instagram elementor-repeater-item-7c2bcc0"
                      href="https://www.instagram.com/northsouthwines_uk/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="elementor-screen-only">Instagram</span>
                      <i className="fab fa-instagram" />{' '}
                    </a>
                  </span>
                  <span className="elementor-grid-item">
                    <a
                      className="elementor-icon elementor-social-icon elementor-social-icon-linkedin elementor-repeater-item-14fc8bb"
                      href="https://www.linkedin.com/company/north-south-wines-uk/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <span className="elementor-screen-only">Linkedin</span>
                      <i className="fab fa-linkedin" />{' '}
                    </a>
                  </span>
                  <span className="elementor-grid-item">
                    <a
                      className="elementor-icon elementor-social-icon elementor-social-icon-linkedin elementor-repeater-item-14fc8bb"
                      href="https://wines.northsouthwines.co.uk/en/my/bookmarks"
                      target="_blank"
                      rel="noreferrer"
                      style={{
                        color: 'white',
                        width: favorites ? 140 : 110,
                        paddingLeft: 2,
                        paddingRight: 2,
                      }}
                    >
                      <div
                        style={{
                          color: 'white',
                          fontSize: 14,
                          verticalAlign: 'middle',
                        }}
                      >
                        {'My Wine List'}
                        {favorites ? ` (${favorites.length})` : ''}
                      </div>
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
